import api from '../utils/api';

const configService = {
  // ==================== ADMIN-ONLY METHODS ====================
  // These methods are restricted to super-admin role only
  // Used exclusively in SystemConfig page which is protected by RoleBasedRoute

  // Get all system configurations (SUPER ADMIN ONLY)
  getAllConfigs: async () => {
    try {
      const response = await api.get('/admin/configs');
      // Return the data from axios response
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get a specific configuration by key (SUPER ADMIN ONLY)
  getConfig: async (key) => {
    try {
      const response = await api.get(`/admin/configs/${key}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update configurations - accepts an object with multiple config key-value pairs (SUPER ADMIN ONLY)
  updateConfigs: async (configs) => {
    try {
      const response = await api.put('/admin/configs', configs);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // ==================== PUBLIC METHODS ====================
  // These methods use public endpoints accessible to all authenticated users

  // Get a specific configuration by key - PUBLIC endpoint (no auth required)
  getPublicConfig: async (key) => {
    try {
      const response = await api.get(`/configs/${key}`);
      return response.data;
    } catch (error) {
      // Return default value if config not found
      if (key === 'WATERMARK_FONT_SIZE') {
        return { data: { value: '14' } }; // Default font size
      }
      throw error;
    }
  },

  // Get Pusher configuration from backend - PUBLIC endpoint (all authenticated users)
  getPusherConfig: async () => {
    try {
      // Fetch each config item individually
      const [clusterRes, idRes, keyRes, secretRes] = await Promise.all([
        api.get('/configs/PUSHER_APP_CLUSTER').catch(e => {
          return { data: null };
        }),
        api.get('/configs/PUSHER_APP_ID').catch(e => {
          return { data: null };
        }),
        api.get('/configs/PUSHER_APP_KEY').catch(e => {
          return { data: null };
        }),
        api.get('/configs/PUSHER_APP_SECRET').catch(e => {
          return { data: null };
        })
      ]);

      // Extract values from responses
      let cluster = clusterRes.data.PUSHER_APP_CLUSTER || 'ap2';
      let appId = idRes.data.PUSHER_APP_ID || '2058547';
      let appKey = keyRes.data.PUSHER_APP_KEY || '1d006bea231b87998a58';
      let appSecret = secretRes.data.PUSHER_APP_SECRET || 'fc0b7590570639576a08';

      // Check if values are encrypted (Laravel encrypted values start with "eyJ")
      // If encrypted, use default values instead
      if (appKey && appKey.startsWith('eyJ')) {
        console.warn('⚠️ Received encrypted Pusher key from backend, using fallback');
        appKey = '1d006bea231b87998a58';
      }
      if (appSecret && appSecret.startsWith('eyJ')) {
        appSecret = 'fc0b7590570639576a08';
      }
      if (appId && appId.startsWith('eyJ')) {
        appId = '2058547';
      }
      if (cluster && cluster.startsWith('eyJ')) {
        cluster = 'ap2';
      }

      // Build Pusher config object
      const pusherConfig = {
        PUSHER_APP_KEY: appKey,
        PUSHER_APP_SECRET: appSecret,
        PUSHER_APP_ID: appId,
        PUSHER_APP_CLUSTER: cluster,
        PUSHER_USE_TLS: true,
        PUSHER_APP_ENCRYPTED: true
      };



      // Validate required fields
      if (!pusherConfig.PUSHER_APP_KEY || !pusherConfig.PUSHER_APP_ID) {

        throw new Error('Missing required Pusher configuration (KEY or ID)');
      }
      return pusherConfig;
    } catch (error) {
      throw error;
    }
  },

  // Test Pusher notification
  testPusherNotification: async (recipientEmails = [], userId = null) => {
    try {

      const payload = {
        title: 'Test Notification 🔔',
        body: 'This is a test notification from Lockbox Admin',
        message: 'This is a test notification from Lockbox Admin', // Include both body and message for compatibility
        type: 'info'
      };

      // Add recipient_emails only if provided and not empty
      if (recipientEmails && recipientEmails.length > 0) {
        payload.recipient_emails = recipientEmails;
      }

      // Always add user_id if provided (for current user)
      if (userId) {
        payload.user_id = userId;
      }


      const response = await api.post('/test-notification', payload);

      // Check if response.data indicates failure
      if (response.data && !response.data.success && response.data.error) {
      }

      // Return the data from the response
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default configService;